<template>
  <div class="d-flex align-center">
    <AppTooltip location="bottom">
      <template #activator="{ props }">
        <img
          :src="projectCategoryIcon"
          :width="width"
          :max-width="width"
          alt="Room type icon"
          v-bind="props"
        />
      </template>
      <span v-if="room.isDataroom">{{ $t('common.RoomTypeIcon.dataroom') }}</span>
      <span v-else>{{ $t('common.RoomTypeIcon.project') }}</span>
    </AppTooltip>
  </div>
</template>

<script>
import AppTooltip from './AppTooltip.vue'
import { getRoomIcon } from './utils/rooms'

export default {
  name: 'RoomTypeIcon',
  components: { AppTooltip },
  props: {
    room: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    projectCategoryIcon () {
      return getRoomIcon(this.room)
    },
  },
}
</script>
